export const HOME_PAGE = {
    BANNER : {
        PRODUCT : "Vivas.AI",
        HEADING : "Bring the power of Gen AI into your workflow",
        SUB_TEXT : "Elevate your enterprise with Vivas.AI using Gen AI for document processing, engaging data conversations, and a suite of AI models to enhance workflow and decision-making, all tailored to your needs."
    },
    CONNECTORS : {
        HEADING : "Don't Code, Just Plug & Play",
        CONTENT : "It's easy to bring these amazing capabilities into your workflow. All you need to do is plug in our models into your workflow using an API.",
        LINK_TEXT : "New to using APIs? We'll help you."
    },
    PRODUCTS : {
        HEADING : "Explore Vivas.AI Products and Services"
    },
    DEPLOYMENTS : {
        HEADING : "Deployment Solutions",
        SAAS : {
            HEADING : "Cloud-based SaaS Solution",
            CONTENT : "Our Cloud-based Software as a Service (SaaS) solution empowers you to benefit from hassle-free integration with our secure servers, entrusting all maintenance and performance concerns to our capable hands. This grants you the freedom to focus solely on your business objectives, leveraging our expertise to streamline operations and maximize efficiency without the burden of technical management."
        },
        SELFHOST : {
            HEADING : "Self-hosting Solution",
            CONTENT : "Self-hosting solutions allow you to take full control of your data and infrastructure, enabling unparalleled customization and security. With our self-hosting options, you have the flexibility to tailor your environment and the cloud providers that you choose to meet your unique needs while ensuring data privacy and compliance.\n\nAutomated Cloud Setup: AWS, Azure and Google.\n\nPull the containers and deploy them anywhere."
        }
    },
    OWN_MODEL_CREATION : {
        HEADING : "Customize Our Models, Make Them Your Own",
        CONTENT : "We recognize the uniqueness of each company's workflow and requirements. That's why we provide the foundation for you to construct your own custom models using ours. A few simple clicks, without any coding, are all that's needed to adjust our models to suit your distinct needs.",
        VIDEO_PLAY_TEXT : "See how"
    },
    INDUSTRIES : {
        HEADING : "Explore Different Industries",
        BUTTON_TEXT : "Explore More"
    },
    WHY_VIVASAI : {
        HEADING : "Why Vivas.AI?"
    },
    OTHERS_OPINION : {
        HEADING : "Discover The Buzz Around Vivas.AI"
    }
}

export const CONTACT_BANNER = {
    UNSUBSCRIBED : {
        HEADING : "Not sure how Vivas.AI can help you?",
        SUB_TEXT : "Give your details for contact you to see how we can help you.",
    }
}

export const HOME_PAGE_STRINGS = {
    BANNER: 'Vivas.AI',
    BANNER_CONTENT1: 'Democratize AI for the Enterprise',
    BANNER_CONTENT2: 'Bring the Power of Gen AI into your workflow',
    // BANNER_CONTENT2: 'Discover and integrate powerful plug-and-play AI models to empower your business.',
    VIVASAI_PLATFORM_HEAD : <span>{"One platform for All your "}<label>Gen AI</label>{" Needs"}</span>,
    VIVASAI_PLATFORM_CONTENT : "Harness the power of Gen AI with Vivas.AI, the platform that revolutionizes your offerings and business operations. Rapidly create AI-powered apps or seamlessly integrate AI with your existing applications.",
    // VIVASAI_EMPOWER_HEAD : "Empowering You with Control and Flexibility",
    VIVASAI_EMPOWER_HEAD : "Vivas.AI: The Gen AI ecosystem",
    VIVASAI_EMPOWER_HEAD2 : "Un-Imaginable Solutions",
    VIVASAI_EMPOWER_CONTENT1 : <><span>{"Multi-Modal     +         Multi-Task         =   “"}<label>{"Infinite Possibilities"}</label>{"”"}</span></>,
    VIVASAI_EMPOWER_CONTENT2 : "\"Your Journey To Infinite Possibilities Begins Here.\"",
    VIVASAI_CONNECTORS_HEAD: "Don't code it, just plug it.",
    VIVASAI_CONNECTORS_HEAD_BOLD: "",
    VIVASAI_CONNECTORS_HEAD_CONT: "",
    VIVASAI_CONNECTORS_SUBTEXT: "Drag & drop AI/ML capabilities to your favourite low-code platforms like Appian, UiPath, BluePrism, Power Automate, or Outsystems. New to low code? Don't worry. Use our API to power up your applications with AI/ML models.",
    VIVASAI_MODEL: "Our Models",
    VIVASAI_MODEL_SUBTEXT: "Just plug & play. It's that simple!",
    TASKS_GROUP: "Model Groups",
    TEXT_ANALYTICS: "Text Analytics",
    TEXT_ANALYTICS_CONTENT: "Analyse unstructured data like customer reviews, emails using natural language processing algorithms to identify customer sentiments, emotions, and entities. Detect spam, or spot spelling mistakes or translate from one language to another.",
    DOC_AI: "Doc.AI",
    DOC_AI_CONTENT: "Convert images of handwritten texts or digital texts into machine-readable formats using optical character recognition (OCR) technologies. Extract key information such as purchase order, invoices, or other data from documents.  ",
    VOICE: "Voice",
    VOICE_CONTENT: "Convert text into natural-sounding, human-like speeches with emotional tones and vice versa. Create engaging and satisfying experience for your customers.",
    VISION: "Vision",
    VISION_CONTENT: "Identify and categorize elements of images, convert audio files into texts and vice versa, detect human faces or famous landmarks or logos. There are a lot more that Vivas.AI offers.",
    KEY_FEATURES: "Key features",
    WHAT_PEOPLE_SAY: "Expert Opinion",
    // WHY_VIVASAI: "Why Vivas.AI?",
    WHY_VIVASAI: "What makes Vivas.AI unique?",
    FIVE_TIMES_FASTER : {
        CONTENT : "Effortlessly create your own powerful AI/ML models with point and click without any assistance, a hundredfold the speed of traditional AI/ML!",
        SPAN_STRING : "100X",
        VIDEO_CAPTION : "Don't take our word for it, come experience it!"
    },
    CONTACT: {
        // TITLE: "Contact us to get started.",
        TITLE: "Check if Vivas.AI is right for you",
        CONTACT_US_TITLE:"Contact us to integrate.",
        SUB_TEXT: "Discover and integrate powerful plug-and-play AI models to empower your business.",
        SUPPORT_TEXT: "If you need support, we're happy to help.",
        LINK_TEXT: "Contact Us",
        SUPPORT_TEXT_CUSTOMER : "If you are a customer and need support, we're happy to help."
    },

    PARTNER : {
        TITLE : "Join us today to fuel innovation through a collaborative partnership"
    }
}
